import React from 'react';
import './App.css';
import EcomStore from './components/EcomStore';

function App() {
  return (
    <div className="App">
   <EcomStore />   
      </div>
  );
}

export default App;
